'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.stylesheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = require('jss-theme-reactor');

var _colorManipulator = require('../styles/colorManipulator');

var _Menu = require('../Menu');

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var stylesheet = exports.stylesheet = (0, _jssThemeReactor.createStyleSheet)('UserAvatar', function (theme) {
  var palette = theme.palette,
      typography = theme.typography;

  var RELATIVE_CAMERA_SIZE = 0.2;
  var ICON_POSITION = 0.775 - RELATIVE_CAMERA_SIZE / 2;

  return {
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '1em',
      width: '1em',
      borderRadius: theme.variables.borderRadius,
      boxSizing: 'border-box',
      overflow: 'hidden',
      userSelect: 'none'
    },
    container: {
      position: 'relative',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: theme.variables.borderRadius,
      boxSizing: 'border-box'
    },
    'default': {
      color: palette.background['default'],
      backgroundColor: (0, _colorManipulator.emphasize)(palette.background['default'], 0.26)
    },
    text: {
      fontSize: '0.6em'
    },
    cursor: {
      cursor: 'pointer'
    },
    img: {
      width: '100%',
      height: 'auto'
    },
    iconBox: {
      height: '.325em',
      width: '.325em',
      color: 'white',
      backgroundColor: typography.highlight.color,
      borderRadius: theme.variables.borderRadius,
      textAlign: 'center',
      left: ICON_POSITION + 'em',
      top: ICON_POSITION + 'em',
      position: 'absolute'
    },
    icon: {
      height: '.2em',
      width: '.2em',
      position: 'absolute',
      top: '.08em',
      left: '.065em'
    }
  };
});

var UserAvatar = (_temp2 = _class = function (_Component) {
  _inherits(UserAvatar, _Component);

  function UserAvatar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserAvatar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserAvatar.__proto__ || Object.getPrototypeOf(UserAvatar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.open = function (open) {
      return _this.setState({ open: open });
    }, _this.handleUserAvatarClick = function () {
      var _this$props$_this$sta = Object.assign({}, _this.props, _this.state),
          open = _this$props$_this$sta.open;

      _this.open(!open);
    }, _this.handleRequestClose = function () {
      return _this.open(false);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserAvatar, [{
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this,
            _classNames;

        var _props$state = Object.assign({}, this.props, this.state),
            alt = _props$state.alt,
            icon = _props$state.icon,
            classNameProp = _props$state.className,
            childrenProp = _props$state.children,
            childrenClassNameProp = _props$state.childrenClassName,
            ComponentProp = _props$state.component,
            open = _props$state.open,
            menuItems = _props$state.menuItems,
            onClick = _props$state.onClick,
            sizes = _props$state.sizes,
            src = _props$state.src,
            srcSet = _props$state.srcSet,
            style = _props$state.style,
            other = _objectWithoutProperties(_props$state, ['alt', 'icon', 'className', 'children', 'childrenClassName', 'component', 'open', 'menuItems', 'onClick', 'sizes', 'src', 'srcSet', 'style']);

        var hasImage = src || srcSet;
        var userAvatarClick = onClick ? function () {
          onClick();
          _this2.handleUserAvatarClick();
        } : menuItems ? this.handleUserAvatarClick : false;
        var Icon = icon;
        var classes = this.context.styleManager.render(stylesheet);
        var className = (0, _classnames2['default'])(classes.root, (_classNames = {}, _defineProperty(_classNames, classes['default'], childrenProp && !hasImage), _defineProperty(_classNames, classes.cursor, userAvatarClick), _classNames), classNameProp);
        var iconBoxClassName = (0, _classnames2['default'])(classes.iconBox, _defineProperty({}, classes.cursor, userAvatarClick));
        var containerProps = Object.assign({
          className: className,
          onClick: userAvatarClick
        }, other);
        var iconBoxProps = {
          className: iconBoxClassName,
          onClick: userAvatarClick
        };

        var children = null;

        if (hasImage) {
          var imgProps = {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes,
            className: classes.img
          };
          children = _react2['default'].createElement('img', _extends({ alt: alt }, imgProps));
        } else if (childrenProp) {
          if (childrenClassNameProp && _react2['default'].isValidElement(childrenProp)) {
            var childrenClassName = (0, _classnames2['default'])(childrenClassNameProp, childrenProp.props.className);
            children = _react2['default'].cloneElement(childrenProp, {
              className: childrenClassName
            });
          } else if (typeof childrenProp === 'string') {
            children = childrenProp.substr(childrenProp.search(/[a-zA-Z]/), 1).toUpperCase();
          } else {
            children = childrenProp;
          }
        }

        return _react2['default'].createElement(
          'div',
          {
            className: classes.container,
            style: style,
            ref: function () {
              function ref(rootNode) {
                return _this2.rootNode = rootNode;
              }

              return ref;
            }()
          },
          _react2['default'].createElement(
            ComponentProp,
            containerProps,
            hasImage ? children : _react2['default'].createElement(
              'span',
              { className: classes.text },
              children
            )
          ),
          icon && _react2['default'].createElement(
            'div',
            iconBoxProps,
            _react2['default'].createElement(Icon, { className: classes.icon })
          ),
          menuItems && _react2['default'].createElement(
            _Menu2['default'],
            {
              open: open,
              anchorEl: this.rootNode,
              onRequestClose: this.handleRequestClose
            },
            _react.Children.map(menuItems, function (child) {
              if (!child) return;
              return _react2['default'].cloneElement(child, {
                onClick: function () {
                  function onClick() {
                    if (child.props.onClick) {
                      child.props.onClick();
                    }
                    _this2.handleRequestClose();
                  }

                  return onClick;
                }()
              });
            })
          )
        );
      }

      return render;
    }()
  }]);

  return UserAvatar;
}(_react.Component), _class.propTypes = {
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: _PropTypes2['default'].string,
  /**
   * SvgIcon to show on Avatar
   */
  icon: _PropTypes2['default'].func,
  /**
   * Used to render icon or text elements inside the Avatar.
   * `src` and `alt` props will not be used and no `img` will
   * be rendered by default.
   *
   * This can be an element, or just a string.
   * If it is a string, a two character initial will be parsed from it.
   */
  children: _PropTypes2['default'].node,
  /**
   * @ignore
   * The className of the child element.
   * Used by Chip to style the Avatar icon.
   */
  childrenClassName: _PropTypes2['default'].string,
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * The component type of the root element.
   */
  component: _PropTypes2['default'].oneOfType([_PropTypes2['default'].string, _PropTypes2['default'].func]),
  /**
   * If `true`, then menu is displayed
   */
  open: _PropTypes2['default'].bool,
  /**
   * Used to render menu items inside the Avatar.
   */
  menuItems: _PropTypes2['default'].node,
  /**
   * sizes desc
   */
  sizes: _PropTypes2['default'].string,
  /**
   * src desc
   */
  src: _PropTypes2['default'].string,
  /**
   * srcSet desc
   */
  srcSet: _PropTypes2['default'].string
}, _class.defaultProps = {
  alt: '',
  component: 'div',
  open: false
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = UserAvatar;


UserAvatar.displayName = 'UserAvatar';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Avatar/UserAvatar.js
// module id = 778
// module chunks = 32